<template>
  <a :href="data.link" target="_blank">
    <div class="home-forum-item flex-col">
      <div class="cover">
        <img v-if="data.id === 1" src="../../../assets/images/forum1.jpg" alt />
        <img v-if="data.id === 2" src="../../../assets/images/forum2.jpg" alt />
        <img v-if="data.id === 3" src="../../../assets/images/forum3.jpg" alt />
        <img v-if="data.id === 4" src="../../../assets/images/forum4.jpg" alt />
      </div>
      <!-- <div class="home-title" v-text="data.title"></div> -->
    </div>
  </a>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {},
  name: "HomeForumBlock",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup() {
    return {};
  },
});
</script>
<style lang="scss" scoped>
.home-forum-item {
  width: 44.3%;
  border-radius: 5px;
  transition: all 0.2s;
  margin-bottom: 20px;
  .cover {
    width: 410px;
    height: 114px;
    border-radius: 5px;
    object-fit: contain;
    transition: all 0.2s;
    img {
      width: 100%;
      height: 100%;
      // object-fit: contain;
      display: block;
      border-radius: 5px;
    }
    &:hover {
      box-shadow: 0 0 16px rgba(0, 0, 0, 0.4);
    }
  }
  .home-title {
    width: 515px;
    height: 44px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    margin: 20px auto 10px;
  }
}
</style>
